/**
 * Platform-admin helpers. `ta-admin` is set on the user record in DynamoDB only.
 */

function unwrapAttr(value) {
  if (value == null) return null;
  if (typeof value === "string" || typeof value === "boolean" || typeof value === "number") {
    return value;
  }
  if (typeof value === "object") {
    if (value.S != null) return value.S;
    if (value.BOOL != null) return value.BOOL;
    if (value.N != null) return value.N;
  }
  return null;
}

export function getUserPlatformType(user = null) {
  let u = user;
  if (!u && typeof window !== "undefined") {
    try {
      u = JSON.parse(localStorage.getItem("user") || "null");
    } catch {
      u = null;
    }
  }
  return unwrapAttr(u?.type) ?? unwrapAttr(u?.user_type) ?? null;
}

export function isTaAdmin(user = null) {
  return getUserPlatformType(user) === "ta-admin";
}
